"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAudioClipStencil = exports.audioClipStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.audioClipStencilDefinition = {
    view: {
        label: 'Audio clip',
        group: 'Audio',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'teaser',
                    'audio-essence',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'uri-title',
                            'featured-media',
                            'transcript',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                ],
            },
        ],
    },
    content: {
        'audio-essence': properties_1.audioEssencePropertyDefinition,
        disciplines: properties_1.disciplinesPropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        standalone: properties_1.standalonePropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        transcript: properties_1.transcriptPropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'global',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'audio-clip',
};
const isAudioClipStencil = (stencil) => {
    return stencil.name === exports.audioClipStencilDefinition.name;
};
exports.isAudioClipStencil = isAudioClipStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaW8tY2xpcC5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL2F1ZGlvLWNsaXAuc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw4Q0FZc0I7QUFFVCxRQUFBLDBCQUEwQixHQUFHO0lBQ3hDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLEtBQUssRUFBRSxPQUFPO1FBQ2QsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxDQUFDLGdCQUFnQixDQUFDO1FBQzlCLFlBQVksRUFBRTtZQUNaO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLEtBQUssRUFBRTtvQkFDTCxPQUFPO29CQUNQLFFBQVE7b0JBQ1IsZUFBZTtpQkFDaEI7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxNQUFNO2dCQUNaLFFBQVEsRUFBRTtvQkFDUjt3QkFDRSxJQUFJLEVBQUUsU0FBUzt3QkFDZixLQUFLLEVBQUU7NEJBQ0wsV0FBVzs0QkFDWCxnQkFBZ0I7NEJBQ2hCLFlBQVk7eUJBQ2I7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFVBQVU7d0JBQ2hCLEtBQUssRUFBRSxDQUFDLFlBQVksQ0FBQztxQkFDdEI7aUJBQ0Y7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxTQUFTO2dCQUNmLEtBQUssRUFBRTtvQkFDTCxhQUFhO29CQUNiLFlBQVk7b0JBQ1osa0JBQWtCO29CQUNsQixhQUFhO2lCQUNkO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsZUFBZSxFQUFFLDJDQUE4QjtRQUMvQyxXQUFXLEVBQUUsMENBQTZCO1FBQzFDLGdCQUFnQixFQUFFLDRDQUErQjtRQUNqRCxVQUFVLEVBQUUseUNBQTRCO1FBQ3hDLFlBQVksRUFBRSx3Q0FBMkI7UUFDekMsa0JBQWtCLEVBQUUsNkNBQWdDO1FBQ3BELGFBQWEsRUFBRSx5Q0FBNEI7UUFDM0MsTUFBTSxFQUFFLHFDQUF3QjtRQUNoQyxLQUFLLEVBQUUsb0NBQXVCO1FBQzlCLFVBQVUsRUFBRSx5Q0FBNEI7UUFDeEMsV0FBVyxFQUFFLHVDQUEwQjtLQUN4QztJQUNELGFBQWEsRUFBRSxFQUFFO0lBQ2pCLEtBQUssRUFBRSxFQUFFO0lBQ1QsTUFBTSxFQUFFO1FBQ04sU0FBUztRQUNULHVCQUF1QjtRQUN2QixRQUFRO1FBQ1IsY0FBYztRQUNkLGVBQWU7UUFDZixZQUFZO1FBQ1osYUFBYTtRQUNiLDhCQUE4QjtRQUM5QixtQkFBbUI7UUFDbkIscUJBQXFCO1FBQ3JCLGdCQUFnQjtRQUNoQixtQkFBbUI7UUFDbkIsYUFBYTtRQUNiLGNBQWM7UUFDZCxZQUFZO0tBQ2I7SUFDRCxJQUFJLEVBQUUsWUFBWTtDQUNZLENBQUE7QUFJekIsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLE9BQW9CLEVBQStCLEVBQUU7SUFDdEYsT0FBTyxPQUFPLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLGtCQUFrQixzQkFFOUIifQ==